export const tr = {
    'banner-default-body': 'Hizmet veya ürün reklamıyla ilgili reklamınızın metni.',
    'banner-default-domain': 'web sitesi adresi',
    'banner-default-title': 'Reklam başlığı'
};
